import React from 'react';

import Close from '../../assets/icon-close.svg';
import './banner-popup.style.css';

class bannerPopup extends React.Component {

    constructor() {
        super();
        this.state = {
            data: null
        }
    }
    componentDidUpdate() {
        if (this.state.data !== null && this.state.data !== '') {
            document.body.classList.add('overlay-hide');
        }
    }
    componentWillUnmount() {
        document.body.classList.remove('overlay-hide');
        this.setState({ data: '' });
    }
    async componentDidMount() {
        const { url } = this.props;
        if (url !== null && url !== '#') {
            const response = await fetch(url);
            const res = await response.text();
            this.setState({ data: res });
        }
    }
    render() {
        const { data } = this.state;
        if (data !== null ) {
            return (
                <div className="modal">
                    <div className="close-popup"><img src={Close} alt="" onClick={() => this.props.closeAction()}></img></div>
                    <div dangerouslySetInnerHTML={{ __html: this.state.data }} ></div>
                </div>
            )

        } else {
            return (
                <div></div>
            )
        }
    }

}

export default bannerPopup;